import { icons } from '../../generic';
import type { ProjectType } from '../../../../shared/projectsV2/common';
import type { IconClassName } from '../../generic';

// Project types mapped to their corresponding icons including `private` to denote when a lock should be displayed.
type ProjectTypeMapping = Record<ProjectType | 'private', { title: string; icon: IconClassName }>;

/**
 * Project types mapped to their corresponding icons.
 */
export const projectTypes: ProjectTypeMapping = {
  private: {
    title: 'Private',
    icon: icons.lock,
  },
  provided: {
    // we use CLI Upload for the title to match the filter UI
    title: 'CLI Upload',
    icon: icons.upload,
  },
  container: {
    title: 'Container',
    icon: icons.cube,
  },
  archive: {
    title: 'Archive',
    icon: icons.archive,
  },
  sbom: {
    title: 'SBOM Import',
    icon: icons.receipt,
  },
  binary: {
    title: 'Binary',
    icon: icons.fileBinary,
  },
  autobuild: {
    // we use Quick Import for the title to match the filter UI
    title: 'Quick Import',
    icon: icons.truckFast,
  },
};
